exports.f = Object.getOwnPropertySymbols;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/modules/_object-gops.js
 ** module id = 211
 ** module chunks = 0
 **/